import { useMemo } from "react";
import { useLanguage } from "./useLanguage";

export function useDateTimeFormat(options?: Intl.DateTimeFormatOptions) {
  const language = useLanguage();
  const optionsStr = JSON.stringify(options ?? {});

  return useMemo(
    () => new Intl.DateTimeFormat(language, JSON.parse(optionsStr)),
    [language, optionsStr],
  );
}
